<template>
  <div class="keshi-main-container">
    <ReturnButton></ReturnButton>
    <HomeButton></HomeButton>
    <div class="keshi-main-content">
      <DiseaseTitle>{{ keShiName }}</DiseaseTitle>
      <div class="keshi-classification">
        <div v-for="(item, index) in keShiObj.disease" :key=index class="keshi-classification-element">
          <button class="keshi-classification-button" @click="goDiseaseDetailPage(item.diseaseCode)"
                  :style="' --clickedUrl: url(' + '\'' + `${btnSelected}` + '\'' +'); --imgUrl: url(' + '\'' + `${btnNotSelected}` + '\'' +');'">
            {{ item.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReturnButton from "@/components/ReturnButton";
import HomeButton from "@/components/HomeButton";
import DiseaseTitle from "@/components/DiseaseTitle";
import btnNotSelected from '@/assets/image/diseasePage/DiseaseButtonNotSelected.png';
import btnSelected from '@/assets/image/diseasePage/DiseaseButtonSelected.png';
import CommonData from "@/assets/js/CommonData";

export default {
  name: 'DiseaseKeShiPage',
  components: {
    HomeButton,
    ReturnButton,
    DiseaseTitle,
  },
  data() {
    return {
      btnSelected,
      btnNotSelected,
      keShiObj: {
        disease:[]
      },
      keShiName: '',
      keShiCode: ''
    };
  },
  methods: {
    goDiseaseDetailPage: function (diseaseCode) {
      this.$router.push({
        path: '/diseaseDetailPage',
        query: {
          diseaseCode,
          keShiCode: this.keShiCode,
          internal: true
        }
      })
    }
  },
  created() {
    let keShiCode = this.keShiCode = this.$route.query.keShi;
    let keShiObj = this.keShiObj = JSON.parse(JSON.stringify(CommonData.keshiList.find(keshi => keshi.keShiCode === keShiCode)));
    this.keShiName = keShiObj.name;
  },
  destroyed() {
  }
}
</script>

<style>
.keshi-main-container {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("../assets/image/NormalBg.png");
  display: flex;
  flex-direction: column;
}

.keshi-classification {
  display: flex;
  flex-wrap: wrap;
  margin: 10vw 3.5vw 0 3.5vw;
}

.keshi-classification-element {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0 8.5vw 0;
}

.keshi-classification-button {
  height: 9.7vw;
  width: 32vw;
  background-size: 100% 100%;
  background-color: transparent;
  background-image: var(--imgUrl);
  border: 0;
  font-size: 4.2vw;
  font-family: "PingFang", serif;
  color: #c8c8c8;
  padding: 0 0 0.6vw 0;
}

.keshi-classification-button:active {
  background-image: var(--clickedUrl);
  color: #0fffff;
}
</style>
